// libraries
import { FC, ReactElement } from 'react'
import _ from 'lodash'

// constants
import { TOOLTIP_PLACEMENT } from 'constants/settings'
import { NO_VALUE_PLACEHOLDER } from 'app/MissionControlMethaneSolution/constants/common'

// components
import { TruncatingTextWithTooltip } from 'components/common/TruncatingTextWithTooltip'

import type { ColumnBodyOptions } from 'primereact/column'

type PlainTextTemplateProps = {
  rowData: unknown
  options: ColumnBodyOptions
}

export const TextCell = ({ text }: { text?: string }) => {
  if (!text) return <>{NO_VALUE_PLACEHOLDER}</>

  return (
    <TruncatingTextWithTooltip
      className='text-capitalize'
      placement={TOOLTIP_PLACEMENT.top}
      title={text}
    >
      <span>{text}</span>
    </TruncatingTextWithTooltip>
  )
}

const TextTemplate: FC<PlainTextTemplateProps> = (
  rowData,
  options
): ReactElement => {
  const { field } = options || {}
  const text = _.get(rowData, field)
  return <TextCell text={text} />
}

export default TextTemplate
